import React from 'react';
import { Grid, Header, Icon, List, Menu, Segment, Label, Button, Message, Popup, Loader } from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import moment from 'moment';
import 'moment/min/locales';
import { FormattedMessage } from 'react-intl';
import { IconHeader } from '../Assets/util/css';

const PAGE_SIZE = 20;

const getNotificationTypeName = (type) => ((window.$locale !== 'bs' && type.translations && type.translations.length)
    ? (type.translations.find(e => e.language === window.$locale) ? type.translations.find(e => e.language === window.$locale).name : type.name)
    : type.name);

export default class Notifications extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newNotifications: [],
            loading: true,
            loadingMore: false,
            showUnreadOnly: true,
            expandedId: null,
            page: 0,
            hasMore: true,
            markingAll: false,
        };
        this.putNotification = this.putNotification.bind(this);
        this.markAllAsRead = this.markAllAsRead.bind(this);
        this.fetchPage = this.fetchPage.bind(this);
        this.loadMore = this.loadMore.bind(this);
        this.setFilter = this.setFilter.bind(this);
    }

    componentDidMount() {
        this.fetchPage(true);
    }

    // Paged fetch. reset=true replaces the list (page 0); otherwise appends the next page.
    fetchPage(reset) {
        const page = reset ? 0 : this.state.page;
        const unread = this.state.showUnreadOnly;
        if (reset) { this.setState({ loading: true }); } else { this.setState({ loadingMore: true }); }
        axios.get(`/notifications/user/paged?page=${page}&size=${PAGE_SIZE}&unread=${unread}`)
            .then(res => {
                const data = Array.isArray(res.data) ? res.data : [];
                this.setState(prev => ({
                    newNotifications: reset ? data : [...prev.newNotifications, ...data],
                    page: page + 1,
                    hasMore: data.length === PAGE_SIZE,
                    loading: false,
                    loadingMore: false,
                }));
            })
            .catch(() => this.setState({ loading: false, loadingMore: false }));
    }

    loadMore() {
        if (!this.state.loadingMore && this.state.hasMore) { this.fetchPage(false); }
    }

    setFilter(showUnreadOnly) {
        if (showUnreadOnly === this.state.showUnreadOnly) return;
        this.setState({ showUnreadOnly, expandedId: null }, () => this.fetchPage(true));
    }

    putNotification(id) {
        axios.put('notifications/change-seen-status/', [id])
            .then(() => {
                // Mark read locally but keep it visible (do not remove while reading).
                this.setState(prev => ({
                    newNotifications: prev.newNotifications.map(n => (n.id === id ? { ...n, seen: true } : n)),
                }));
            })
            .catch(() => toast(<FormattedMessage id="common.error" />));
    }

    markAllAsRead() {
        if (this.state.markingAll) return;
        this.setState({ markingAll: true });
        axios.put('notifications/mark-all-as-read/')
            .then(() => {
                // Keep them visible (now read); they drop out on next filter/reload.
                this.setState(prev => ({
                    newNotifications: prev.newNotifications.map(n => ({ ...n, seen: true })),
                    markingAll: false,
                }));
            })
            .catch(() => {
                this.setState({ markingAll: false });
                toast(<FormattedMessage id="common.error" />);
            });
    }

    render() {
        // eslint-disable-next-line no-unused-expressions
        window.$locale === 'en' ? moment.locale('en-gb') : moment.locale('bs');
        // Server already filters (unread param) and paginates.
        const list = this.state.newNotifications;
        return (
            <div>
                <Header as="h1">  <FormattedMessage id="common.notifications" /></Header>
                <Grid columns={2} stackable centered >
                    <Grid.Row stretched>
                        <Grid.Column width={16} >

                            <Segment.Group raised clearing>
                                <Segment clearing>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                                        <Header as="h3" style={{ margin: 0 }}>
                                            <Header.Content><FormattedMessage id="common.allNotificationsTitle" /></Header.Content>
                                        </Header>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                            <Button.Group basic size="small">
                                                <Button color="blue" active={this.state.showUnreadOnly} onClick={() => this.setFilter(true)}>
                                                    <FormattedMessage id="common.filterUnread" />
                                                </Button>
                                                <Button color="blue" active={!this.state.showUnreadOnly} onClick={() => this.setFilter(false)}>
                                                    <FormattedMessage id="common.filterAll" />
                                                </Button>
                                                <Popup
                                                    content={() => <FormattedMessage id="common.markAllAsReadHint" />}
                                                    position="left center"
                                                    trigger={
                                                        <Button color="blue" onClick={this.markAllAsRead} loading={this.state.markingAll} disabled={this.state.markingAll}>
                                                            <Icon name="envelope open outline" />
                                                            <FormattedMessage id="common.markAllAsRead" />
                                                        </Button>
                                                    }
                                                />
                                            </Button.Group>
                                        </div>
                                    </div>
                                </Segment>

                                <Segment > {this.state.loading ?
                                    <div style={{ padding: '30px 0' }}><Loader active inline="centered" /></div> :
                                    list.length === 0 ?
                                    <div>
                                        <p><FormattedMessage id="common.noNewNotifications" /></p>
                                        {this.state.showUnreadOnly &&
                                            <p><FormattedMessage id="common.selectAllToSeeRead" /></p>
                                        }
                                    </div> :
                                    <Menu vertical fluid divided relaxed style={{ marginBottom: '12px' }}>
                                        {list.map((el) =>
                                            (<Menu.Item
                                                key={el.id}
                                                style={!el.seen ? { backgroundColor: '#dff0f7' } : {}}
                                                active={el.id === this.state.expandedId}
                                                onClick={() => {
                                                    if (!el.seen) { this.putNotification(el.id); }
                                                    this.setState({ expandedId: this.state.expandedId === el.id ? null : el.id });
                                                }}
                                            >
                                                {!el.seen && <Label color="teal"><FormattedMessage id="common.new" /></Label>}
                                                <List.Content>
                                                    <List.Header as="h4" style={{ color: '#1a6aa5' }}>
                                                        {el.notification ? el.notification.subject : <FormattedMessage id="common.noNotificationText" />}
                                                    </List.Header>

                                                    { el.id === this.state.expandedId && <List.Description style={{
                                                        textAlign: 'justify', textJustify: 'inter-word', color: '#000000', paddingRight: '15px'
                                                    }}
                                                    > {el.notification && <UnsafeComponent html={el.notification.text} />}
                                                        <br />
                                                    </List.Description>}

                                                    <List.Description as="h6" style={{ color: 'gray' }}>
                                                        <Icon color="teal" name="user" />
                                                        &nbsp;
                                                        {

                                                            el.notification && el.notification.sender && el.notification.sender.employee ?
                                                                el.notification.sender.employee.person.lastName + ' ' + el.notification.sender.employee.person.firstName + '    '
                                                                : 'eUNSA '
                                                        }
                                                        &nbsp;&nbsp;&nbsp;
                                                        <Icon color="teal" name="calendar alternate outline" />
                                                        &nbsp;
                                                        {

                                                            moment(el.notification && el.notification.timestamp).calendar(null, window.$locale === 'bs' ? {
                                                                sameDay: '[danas u] LT',
                                                                nextDay: '[sutra u] LT',
                                                                nextWeek: 'D. M. YYYY. [u] LT',
                                                                lastDay: '[jučer u] LT',
                                                                lastWeek: 'D. M. YYYY. [u] LT',
                                                                sameElse: 'D. M. YYYY. [u] LT'
                                                            } : {
                                                                lastDay: '[Yesterday at] LT',
                                                                sameDay: '[Today at] LT',
                                                                nextDay: '[Tomorrow at] LT',
                                                                lastWeek: 'D. M. YYYY. [at] LT',
                                                                nextWeek: 'D. M. YYYY. [at] LT',
                                                                sameElse: 'D. M. YYYY. [at] LT'
                                                            })
                                                        }
                                                        &nbsp;&nbsp;&nbsp;
                                                        <Icon color="teal" name="mail" />
                                                        &nbsp;
                                                        {
                                                            el.notification && el.notification.notificationType &&
                                                                getNotificationTypeName(el.notification.notificationType)
                                                        }
                                                    </List.Description>


                                                </List.Content>
                                            </Menu.Item>))}
                                    </Menu>

                                }
                                </Segment>

                                {!this.state.loading && this.state.newNotifications.length > 0 && this.state.hasMore &&
                                    <Segment textAlign="center">
                                        {this.state.loadingMore ?
                                            <Loader active inline="centered" size="small" /> :
                                            <Button basic color="blue" size="small" onClick={this.loadMore}>
                                                <Icon name="angle down" />
                                                <FormattedMessage id="common.loadMore" values={{ count: PAGE_SIZE }} />
                                            </Button>
                                        }
                                    </Segment>
                                }

                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row >
                </Grid>

            </div>
        );
    }
}

function UnsafeComponent({ html }) {
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
}



// WEBPACK FOOTER //
// ./src/views/Notifications/Notifications.js